import { useTranslate } from "@growtherapy/i18n";
import { Text, Button, Icon, Card, CardSection } from "@growtherapy/sprout-ui";
import { faPause } from "@fortawesome/pro-solid-svg-icons";
import { useAtomValue } from "jotai";
import { Translate } from "../../i18n";
import { otherPatientConsentedInSessionAtom } from "./state";

type RecordingNoticeProps = {
  onClose: () => void;
  otherPatientConsentedInSession: boolean;
};

export function RecordingNotice({
  onClose,
  otherPatientConsentedInSession,
}: RecordingNoticeProps) {
  const t = useTranslate();

  return (
    <Card className="w-[88vw] xs:max-w-[25rem] rebrand:p-450">
      <CardSection className="pb-4 rebrand:pb-300">
        <Text
          variant="sm"
          className="text-neutral-800 rebrand:text-text-default rebrand:typography-body-small"
        >
          {otherPatientConsentedInSession ? (
            <Translate
              i18nKey="telehealth-core:consent.anotherParticipantHasConsentedUseThePauseButton"
              components={{
                1: <Icon aria-hidden icon={faPause} />,
                2: <span className="sr-only" />,
              }}
            />
          ) : (
            <Translate
              i18nKey="telehealth-core:consent.theSessionIsBeingTranscribedUseThePauseButton"
              components={{
                1: <Icon aria-hidden icon={faPause} />,
                2: <span className="sr-only" />,
              }}
            />
          )}
        </Text>
      </CardSection>
      <CardSection className="pb-4 rebrand:pb-0">
        <Button onClick={onClose} use="primary" className="w-full">
          {t("telehealth-core:consent.gotIt")}
        </Button>
      </CardSection>
    </Card>
  );
}

export function RecordingNoticeWrapper({
  ...rest
}: Omit<RecordingNoticeProps, "otherPatientConsentedInSession">) {
  const otherPatientConsentedInSession = useAtomValue(
    otherPatientConsentedInSessionAtom,
  );
  return (
    <RecordingNotice
      {...rest}
      otherPatientConsentedInSession={otherPatientConsentedInSession}
    />
  );
}
